import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { ScanLine } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Public page meant to be displayed on a tablet/TV at the facility entrance.
 * Walk-in customers scan the QR with their phone to sign in or continue as a guest.
 */
const WaiverQR = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const memberUrl = `${origin}/checkin?source=qr`;
  const guestUrl = `${origin}/checkin?guest=1&source=qr`;

  return (
    <div className="min-h-[90vh] bg-black text-spike-text flex items-center justify-center px-6 py-12" data-testid="waiver-qr-page">
      <div className="max-w-xl w-full text-center">
        <div className="inline-flex items-center gap-2 text-xs font-orbitron font-bold text-spike-blue-light tracking-[0.3em] uppercase">
          <ScanLine className="w-3.5 h-3.5" /> Liability Waiver · Scan & Sign
        </div>
        <h1 className="mt-4 font-orbitron text-4xl sm:text-5xl font-black uppercase text-spike-text">
          Welcome to <span className="text-spike-blue-light">Spike Sports</span>
        </h1>
        <p className="mt-3 text-base text-spike-text-muted font-exo leading-relaxed">
          All players must sign our digital liability waiver before entering the playing area.
          Scan the QR code below on your phone — sign in or continue as a guest, then check your email for your front-desk QR.
        </p>

        <div className="mt-10 inline-block bg-white p-6 rounded-lg shadow-[0_0_60px_rgba(31,169,240,0.35)]" data-testid="waiver-qr-image">
          <QRCodeSVG value={memberUrl} size={280} level="H" includeMargin={false} />
        </div>

        <p className="mt-6 text-xs font-orbitron uppercase tracking-[0.3em] text-spike-dim">
          Member / account holder
        </p>
        <p className="text-spike-text-muted text-sm break-all mt-1" data-testid="waiver-qr-url">{memberUrl}</p>

        <p className="mt-6 text-xs font-orbitron uppercase tracking-[0.3em] text-spike-dim">
          Guest walk-in (no account)
        </p>
        <p className="text-spike-text-muted text-sm break-all mt-1">{guestUrl}</p>

        <ol className="mt-10 text-left max-w-md mx-auto text-sm space-y-3 font-exo">
          <li className="flex gap-3"><span className="font-orbitron text-spike-blue-light font-bold">01</span><span>Scan the QR and sign the waiver on your phone.</span></li>
          <li className="flex gap-3"><span className="font-orbitron text-spike-blue-light font-bold">02</span><span>Check your email for your personal check-in QR.</span></li>
          <li className="flex gap-3"><span className="font-orbitron text-spike-blue-light font-bold">03</span><span>Show that email QR at the front desk to check in.</span></li>
        </ol>

        <p className="mt-8 text-xs text-spike-dim font-exo">
          Staff scanner: <Link to="/scantocheckin" className="text-spike-blue-light underline">/scantocheckin</Link>
        </p>
      </div>
    </div>
  );
};

export default WaiverQR;
